import { useEffect, useCallback, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'

import analytics from '@src/analytics'
import { helpWidget } from '@src/lib/HelpWidget'
import postMessage from '@src/lib/postMessage'

import {
  userSelector,
  currentRetailerAccountSelector,
} from '../../../stores/app/selectors'
import IGAutomation from '../../shared/IGAutomation/IGAutomation'

//Temporary page meant to be used by R1 in an iframe only.
//IgAutomationPage
export function IGAutomationPage() {
  /** @type {React.RefObject<HTMLDivElement>} */

  const containerRef = useRef(null)

  const currentUser = useSelector(userSelector) //TODO: Eventually replace this with nice hook
  const currentRetailerAccount = useSelector(currentRetailerAccountSelector) //TODO: Eventually replace this with nice hook

  useEffect(() => {
    //Hacky, supress the HelpScout beacon on this page.
    try {
      helpWidget.hideAll()
    } catch (error) {
      console.error(error)
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (!entry) {
        return
      }

      postMessage(window.parent, {
        type: 'IgAutomation/size',
        payload: {
          height: entry.contentRect.height,
        },
      })
    })
    observer.observe(containerRef.current)

    postMessage(window.parent, {
      type: 'IgAutomation/load',
    })

    return () => {
      observer.disconnect()
    }
  }, [])
  const handleOnClose = useCallback((payload) => {
    postMessage(window.parent, {
      type: 'IgAutomation/close',
      payload: {
        ...payload,
        ...(ref.current ? ref.current() : undefined),
      },
    })
  }, [])
  const params = useParams()
  const { retailerSlug } = params
  const brandName = currentRetailerAccount.retailers.find(
    (retailer) => retailer.brand.slug === retailerSlug,
  ).brand.name
  const brandId = currentRetailerAccount.retailers.find(
    (retailer) => retailer.brand.slug === retailerSlug,
  ).brand.id

  useEffect(() => {
    analytics.track({
      event: 'View',
      type: 'Saw IG Automation Form',
      data: {
        source: 'IG Share Flow',
        feature: 'IG Auto Share',
      },
    })
  }, [])

  const ref = useRef(null)

  if (currentUser && currentRetailerAccount) {
    return (
      <div ref={containerRef}>
        <IGAutomation
          onClose={handleOnClose}
          isIframe
          brandName={brandName}
          brandId={brandId}
          ref={ref}
        />
      </div>
    )
  } else {
    return null
  }
}
